let cachedWindowScrollbarWidth = undefined

/**
 * Sets or removes the 'overflow-hidden' and 'overscroll-y-none' classes on the HTML element,
 * and adjusts the padding to account for the scrollbar width.
 *
 * @param {boolean} addOverflow - If true, adds the classes and padding. If false, removes them.
 */
const setHtmlElementOverflowHidden = (addOverflow) => {
  const operation = addOverflow ? 'add' : 'remove'

  const htmlElement = document.getElementsByTagName('html')[0]

  if (!htmlElement) {
    return
  }

  cachedWindowScrollbarWidth =
    cachedWindowScrollbarWidth ?? window.innerWidth - htmlElement.clientWidth

  if (operation === 'add') {
    htmlElement.style.overflow = 'hidden'
    htmlElement.style.overscrollBehaviorY = 'none'
  } else {
    htmlElement.style.removeProperty('overflow')
    htmlElement.style.removeProperty('overscroll-behavior-y')
  }

  const paddingValue = addOverflow ? `${cachedWindowScrollbarWidth}px` : ''

  htmlElement.style.paddingRight = paddingValue
}

export default setHtmlElementOverflowHidden
